export const isAuthenticated = state => state.auth.authenticated;
export const auth = state => state.auth;
export const appointments = state => state.auth.appointments;
export const isFetchingAppointments = state => state.auth.isFetchingAppointments;
